module.exports = __webpack_public_path__ + "img/JPM.1b5a7d18.png";